type PlainObject = {
  [key: string]: string | number | boolean | null | undefined
}

// Type for complex metadata that can contain arrays and nested objects
export type ComplexMetadata = Record<
  string,
  | string
  | number
  | boolean
  | null
  | undefined
  | Array<string | number>
  | Record<string, object | string | number | boolean | null | undefined>
>

export function flattenComplexObject(
  metadata: ComplexMetadata,
  prefix = ''
): PlainObject {
  const plainMetadata: PlainObject = {}

  Object.entries(metadata).forEach(([key, value]) => {
    const newKey = prefix ? `${prefix}.${key}` : key

    if (Array.isArray(value)) {
      plainMetadata[newKey] = value.join(',')
    } else if (typeof value === 'object' && value !== null) {
      // For nested objects, recursively flatten them
      if (typeof value === 'object' && !Array.isArray(value)) {
        const nestedObj = value as Record<string, any>
        Object.assign(plainMetadata, flattenComplexObject(nestedObj, newKey))
      } else {
        plainMetadata[newKey] = JSON.stringify(value)
      }
    } else {
      plainMetadata[newKey] = value as
        | string
        | number
        | boolean
        | null
        | undefined
    }
  })

  return plainMetadata
}
